const DISCOUNT_TYPE = {
  PERCENTAGE_DISCOUNT: "percentage_discount",
  AMOUNT_DISCOUNT: "fixed_amount_discount",
  FIXED_PRICE: "fixed_price_discount",
  FREE_SHIPPING: "free_shipping",
  /** Auto-applied free gift line (not entered by customer). */
  GLOBAL_FREE_ARTICLE: "global_free_article",
};

const BANNER_VARIANT = {
  INFO: "info",
  WARNING: "warning",
  DANGER: "danger",
  SUCCESS: "success",
};

module.exports = {
  DISCOUNT_TYPE,
  BANNER_VARIANT,
};
